import {
  IBaseTyreOffer,
  IProductListState,
  IQuoteSetting,
  IQuoteTyreOffer,
  ISearchTypeArgs,
} from '~/purchase/types';
import { IUserCustomer } from '~/common/types';
import { QuoteProductResult, QuoteTableHeader } from '~/purchase/components';

type Props = {
  items: Array<IQuoteTyreOffer>;
  pointOfSaleView: boolean;
  requestedQuantity: number;
  customer: IUserCustomer;
  quoteSetting: IQuoteSetting;
  searchType: ISearchTypeArgs['searchType'];
  searchQuery: IProductListState['searchQuery'];
  onUpdateQuery: (tyreOffer: IBaseTyreOffer) => IBaseTyreOffer | undefined;
};

function QuoteLinesDisplay({
  items,
  pointOfSaleView,
  requestedQuantity,
  customer,
  quoteSetting,
  searchType,
  searchQuery,
  onUpdateQuery,
}: Props) {
  return (
    <>
      <QuoteTableHeader pointOfSaleView={pointOfSaleView} />
      {items.map((item) => (
        <QuoteProductResult
          key={item.tyre.ean}
          tyreOffer={item}
          defaultQuantity={requestedQuantity}
          customer={customer}
          showBfDiscount={quoteSetting.showBfDiscount}
          pointOfSaleView={pointOfSaleView}
          searchType={searchType}
          searchQuery={searchQuery}
          onUpdateQuery={onUpdateQuery}
          type='LINE'
        />
      ))}
    </>
  );
}

export default QuoteLinesDisplay;
